import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import zh from './locale/zh/translation.json'
import en from './locale/en/translation.json'
import fr from './locale/fr/translation.json'
import it from './locale/it/translation.json'
import pl from './locale/pl/translation.json'
import es from './locale/es/translation.json'
import de from './locale/de/translation.json'
import sv from './locale/sv/translation.json'

i18n.use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en,
      zh,
      fr,
      it,
      pl,
      es,
      de,
      sv
    },
    lng: document.getElementById('EmailPreferenceCenter').getAttribute('data-language') || document.querySelector("html").lang || 'en',
    fallbackLng: 'en',  // if user computer language is not on the list of available languages, than we will be using the fallback language specified earlier
    ns: ['translations'],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: {
      useSuspense: false
    },

  });

export default i18n;
